<section class="px-4">
  <div class="component-header-container">
    <div class="list_Header_section">
      <div class="page_header">
        <button class="back_icon me-2" (click)="goBack()">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
        <h3 translate class="m-0 page_header_title">Page Wise Components</h3>
      </div>
      <div *ngIf="actiondata?.create">
        <button
          mat-raised-button
          color="primary"
          (click)="addPageWiseComponentsList()"
          translate
        >
          + Add Page Components
        </button>
      </div>
    </div>
  </div>

  <main class="component_list_container mt-3 card_container">
    <!-- Empty state -->
    <div *ngIf="items?.length === 0" class="empty-state">
      <mat-icon>inbox</mat-icon>
      <p translate>No components found</p>
      <button
        translate
        mat-stroked-button
        color="primary"
        (click)="addPageWiseComponentsList()"
      >
        Create your first component
      </button>
    </div>

    <!-- List items -->
    <mat-card *ngFor="let item of items" class="component_card_container">
      <div class="component_card_content">
        <div class="card-text-content">
          <mat-card-title class="card-title mat-subtitle-1">
            {{ item.name }}
          </mat-card-title>
          <div class="card-model-status">
            <div *ngIf="item.model_name" class="card-model-name">
              {{ item.model_name }}
            </div>
            <div *ngIf="item.status" class="status-wrapper" aria-label="Status">
              <mat-divider vertical></mat-divider>

              <span
                class="card-status-badge"
                [ngClass]="{
                  'status-active': item.status === 'ACTIVE',
                  'status-inactive': item.status === 'INACTIVE',
                }"
              >
                {{ item.status | titlecase }}
              </span>
            </div>
          </div>
        </div>
        <div class="component_card_action">
          <button mat-button class="card_action_view" (click)="ViewItem(item)">
            <span translate>View</span>
          </button>
          <div
            class="action_button"
            [matMenuTriggerFor]="menu"
            aria-label="Actions"
          >
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <mat-menu #menu="matMenu">
            <p
              class="m-0"
              mat-menu-item
              (click)="editPageWiseComponentsList(item)"
            >
              <span translate>Edit</span>
            </p>
            <p
              class="m-0"
              mat-menu-item
              (click)="deletePageWiseComponentsList(item.id)"
            >
              <span translate>Delete</span>
            </p>
            <p
              class="m-0"
              mat-menu-item
              (click)="updatePageWiseComponentsStatus(item)"
              [disabled]="loading"
              [ngClass]="{
                status_color_active: item.status === 'ACTIVE',
                status_color_inactive: item.status === 'INACTIVE',
              }"
            >
              <span>{{
                item.status === "ACTIVE"
                  ? "ACTIVE"
                  : ("INACTIVE" | translatepipe)
              }}</span>
              <mat-progress-spinner
                *ngIf="loading"
                diameter="16"
                mode="indeterminate"
                [style.marginLeft.px]="8"
              ></mat-progress-spinner>
            </p>
          </mat-menu>
        </div>
      </div>
    </mat-card>
  </main>
</section>
